<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" class="h-dialog2 wuliu" append-to-body>
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>发票信息录入</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine">
                <el-form ref="form" :model="fpform" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                    <!--<el-form-item  label="不含税金额" class="h-elformWrap-2">
                        <el-input  v-model="fpform.totalMoney" :disabled=true></el-input>
                    </el-form-item>
                    <el-form-item  label="含税金额" class="h-elformWrap-2">
                        <el-input  v-model="includeTaxAmount" :disabled=true></el-input>
                    </el-form-item>-->


                    <el-form-item  label="发票号" class="h-elformWrap-2">
                        <el-input  v-model="fpform.invoiceNumber" placeholder="请填写发票号"></el-input>
                    </el-form-item>
                    <el-form-item label="发票日期" class="h-elformWrap-2">
                        <el-date-picker
                                placeholder="请选择"
                                v-model="fpform.invoiceDate"
                                clearable
                                type="date"
                                value-format="yyyy-MM-dd" >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="发票金额" class="h-elformWrap-2">
                        <el-input v-model="fpform.noTaxAmount" placeholder="请填写发票金额" readOnly></el-input>
                    </el-form-item>
                    <el-form-item label="发票税率" class="h-elformWrap-2">
                        <brselect category="cgshuilv" v-model="fpform.taxRate"
                                  :v="fpform.taxRate" :disabled=true></brselect>
                    </el-form-item>
                    <el-form-item label="价税合计" class="h-elformWrap-2">
                        <el-input v-model="fpform.includeTaxAmount" placeholder="请填写发票税额" ></el-input>
                    </el-form-item>
                    <el-form-item label="发票税额" class="h-elformWrap-2">
                        <el-input v-model="fpform.taxAmount" placeholder="请填写发票税额"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">

                <el-button class="h-btn h-formBtn" type="primary" @click="saveTo2">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import big from 'big.js'
    export default {
        name: "alluser",
        data(){
            return {
                fpform:{
                    noTaxAmount:'',
                    taxRate:'',
                    totalMoney:0.0,
                    includeTaxAmount:'',
                    invoiceNumber:'',
                    taxAmount:''
                }
            }
        },
        methods: {
            /*changeMoney(){
                const  noTaxAmount = parseFloat(this.fpform.noTaxAmount);
                if(this.fpform.taxRate=='JC') {
                    this.fpform.includeTaxAmount = parseFloat(new big(noTaxAmount).times("1.13").toFixed(2));
                }else if(this.fpform.taxRate=='J0') {
                    this.fpform.includeTaxAmount = parseFloat(new big(noTaxAmount).times("1").toFixed(2));
                }else if(this.fpform.taxRate=='JQ') {
                    this.fpform.includeTaxAmount = parseFloat(new big(noTaxAmount).times("1.06").toFixed(2));
                }else if(this.fpform.taxRate=='J5') {
                    this.fpform.includeTaxAmount = parseFloat(new big(noTaxAmount).times("1.09").toFixed(2));
                }
            },*/
            saveTo2(){
                if(!this.fpform.invoiceNumber){
                    this.$message.error("发票号不能为空");
                    return;
                }
                if(!this.fpform.invoiceDate){
                    this.$message.error("发票日期不能为空");
                    return;
                }
                if(!this.fpform.noTaxAmount){
                    this.$message.error("发票金额不能为空");
                    return;
                }
                if(!this.fpform.taxAmount){
                    this.$message.error("发票税额不能为空");
                    return;
                }
                ss.invoiceApplyList.saveInvoice(this.fpform).then(rd=> {
                    if(rd.f){
                        this.$message.success("保存成功");
                        this.$emit('saveorsubmit')
                    }else{
                        this.$message.error(rd.msg);
                    }
                });
            },

        },
        created(){
          this.fpform.taxRate=this.taxCode;
          this.fpform.supplierCode=this.supplierCode;
          this.fpform.supplierName=this.supplierName;
          this.fpform.companyCode=this.companyCode;
          this.fpform.totalMoney=this.totalMoney;
          this.fpform.noTaxAmount=this.totalMoney;
          this.fpform.applyList=this.applyList;
          this.fpform.currency=this.currency;
        },
        computed: {

        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            totalMoney: {
                type:Number,
            },
            applyList:{
                type:Array,
            },
            includeTaxAmount: {
                type:Number,
            },
            taxCode:{
                type:String,
            },
            supplierCode:{
                type:String,
            },
            supplierName:{
                type:String,
            },
            companyCode:{
                type:String,
            },
            currency:{
                type:String,
            }

        }
    }
</script>

<style>
    l-formlines .h-dialogForm .h-elformWrap-2 .el-form-item__label{
        width: 30%;
    }
    .l_timeline .el-timeline-item__node--large{
        background: url(../../assets/images/l_dian.png) center no-repeat;
        background-size: cover;
        width: 0.14rem;
        height: 0.14rem;
    }
    .ljjdiolog .el-dialog__body{
        padding: 0px 20px;
    }
    .ljjpaginations .el-pagination__sizes{
        display: none!important;
    }
    .ljjpaginations .el-pagination__jump{
        display: none!important;
    }
</style>
